import React from "react";
import Layout from "../layouts/index.jsx";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import PageTitleContainer from "../containers/global/page-title/index.jsx";
import ServiceContainer from "../containers/service-box/index.jsx";
import PricingContainer from "../containers/global/pricing/index.jsx";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import SeoData from "../data/seo.json";

const ServicePage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO {...SeoData["/service"]} pathname="/service" />
                <div className="wrapper">
                    <Header />
                    <div className="main-content site-wrapper-reveal">
                        <PageTitleContainer
                            variant="academic"
                            subTitle="JEONG HWAN-KYO DERMATOLOGY CLINIC"
                            title="<span>진료 안내</span>"
                        />
                        <ServiceContainer />
                        <PricingContainer pricingClassOption="noborder-line" />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default ServicePage;
